"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmSceneStagger
 * @author xlongjiang
 * @created 2025-11-03 06:21:57
 */
const TabPanel = _tpmProductIntl.Tab.TabPanel;
/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmSceneStaggerData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList;
  const handleItems = itemList.map((item, tab) => {
    const text = item.text,
      _item$items = item.items,
      items = _item$items === void 0 ? [] : _item$items;
    const handleData = items.map((item, index) => {
      const _item$title = item.title,
        title = _item$title === void 0 ? '' : _item$title,
        _item$desc = item.desc,
        desc = _item$desc === void 0 ? '' : _item$desc,
        _item$listTitle = item.listTitle,
        listTitle = _item$listTitle === void 0 ? '' : _item$listTitle,
        _item$listItems = item.listItems,
        listItems = _item$listItems === void 0 ? [] : _item$listItems,
        _item$advantageTitle = item.advantageTitle,
        advantageTitle = _item$advantageTitle === void 0 ? '' : _item$advantageTitle,
        _item$advantageItems = item.advantageItems,
        advantageItems = _item$advantageItems === void 0 ? [] : _item$advantageItems,
        _item$buttonList = item.buttonList,
        buttonList = _item$buttonList === void 0 ? [] : _item$buttonList,
        img = item.img,
        previewImg = item.previewImg,
        video = item.video,
        _item$videoPopup = item.videoPopup,
        videoPopup = _item$videoPopup === void 0 ? false : _item$videoPopup;
      const handleBtn = buttonList.map((item, key) => {
        const label = item.label,
          href = item.href;
        const buttonExtendProps = {
          'report-event': 'click_SceneStagger_btn',
          'report-ext1': tab,
          'report-ext2': index,
          'report-ext3': key,
          target: '_blank'
        };
        if (key === 0) {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            href: href,
            icon: true,
            align: "center"
          }, buttonExtendProps), label);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href,
          icon: true,
          align: "center",
          type: 'weak'
        }, buttonExtendProps), label);
      });
      const handleAdvantage = advantageItems.map((item, key) => {
        const _item$title2 = item.title,
          title = _item$title2 === void 0 ? '' : _item$title2,
          _item$desc2 = item.desc,
          desc = _item$desc2 === void 0 ? '' : _item$desc2,
          _item$href = item.href,
          href = _item$href === void 0 ? '' : _item$href,
          icon = item.icon,
          activeIcon = item.activeIcon;
        const linkExtendProps = {
          'report-event': 'click_SceneStagger_advantage_link',
          'report-ext1': tab,
          'report-ext2': index,
          'report-ext3': key,
          target: '_blank'
        };
        return _objectSpread({
          title: title || '',
          desc: desc || '',
          href,
          icon: (0, _componentUtils.doComponentsUploadEvent)(icon || '').url,
          activeIcon: (0, _componentUtils.doComponentsUploadEvent)(activeIcon || '').url
        }, linkExtendProps);
      });
      return {
        title: title || '',
        desc,
        list: !!listItems.length ? {
          title: listTitle || '',
          data: listItems.map(item => item.text)
        } : null,
        advantage: advantageTitle || !!advantageItems.length ? {
          title: advantageTitle || '',
          data: handleAdvantage
        } : null,
        btns: !!buttonList.length ? handleBtn : null,
        img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
        previewImg: (0, _componentUtils.doComponentsUploadEvent)(previewImg || '').url,
        video: (0, _componentUtils.doComponentsUploadEvent)(video || '').url,
        videoPopup
      };
    });
    return {
      text: text || '',
      items: !!items.length ? handleData : null
    };
  });
  return {
    porintId,
    tag: tag || '',
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    itemList: !!itemList.length ? handleItems : null
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmSceneStagge = formatTpmSceneStaggerData(data, {
        domains
      }),
      porintId = _formatTpmSceneStagge.porintId,
      tag = _formatTpmSceneStagge.tag,
      title = _formatTpmSceneStagge.title,
      desc = _formatTpmSceneStagge.desc,
      itemList = _formatTpmSceneStagge.itemList;
    console.log('itemList:', itemList);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmSceneStagger`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmSceneStagger', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      className: "tpm-product-intl-scene2__section",
      tag: tag,
      title: title,
      desc: desc
    }, itemList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: itemList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, itemList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Scene2, {
      data: item.items
    })))) : itemList.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.Scene2, {
      key: index,
      data: item.items
    }))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}